export class DocumentModel {
    fileName?: string;
    fileExt?: string;
    fileSize?: number;
    fileType?: string;
    base64FileString?: string;
    fileBytes?: any;
}